module.exports = __webpack_public_path__ + "static/img/1.a4d23aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news18/1.png
// module id = iDVN
// module chunks = 1